<template>
    <div>
        <div class="seachBox flex">

          <div class="seachList"><span class="name">功能名称：</span>
            <a-select v-model="seach.category" class="seachs" placeholder="请选择" allowClear>
              <a-select-option :value="item.id" v-for="item in seachList">
                {{item.name}}
              </a-select-option>
            </a-select>
          </div>
            <div class="seachList  ">
                <a-button type="primary" size="default" class="seachBtn" @click="getList(1)" style="margin-right: 15px">
                    查询
                </a-button>
                <a-button size="default" class="seachBtn" @click="resetSeach()">重置</a-button>
            </div>
            <div class="seachList no"></div>
            <div class="seachList no"></div>
          <div class="seachList no"></div>
            <div class="seachList no"></div>
        </div>
        <a-table id="tables" :columns="columns" :data-source="data" :loading="loading" :pagination="false" rowKey="id" >
<!--            <span slot="list_order" slot-scope="text, record">-->
<!--                <a-input   v-model="record.list_order" class="inputs" size="small"/>-->
<!--            </span>-->
            <span slot="list_order" slot-scope="text, record">
                <img src="../../../assets/drag.png" alt="" class="dragicon">
            </span>
            <span slot="status" slot-scope="text, record">
                 <a-switch   @click="onChange(record)"
                           :checked="text==1?true:false"   />
            </span>
            <span slot="action" slot-scope="text, record">

                  <a @click="edit(text.id,text.type,text.yd_is_show, text.ai_type)" >编辑</a>

            </span>
        </a-table>
        <ArticleForm :visible="visible" :title="title" :editId="editId"
                     @changVisible=" () => { this.visible = false;this.editId=''; this.getList()}  "/>

    </div>
</template>

<script>
    import API from "./api";
    import moment from 'moment';
    import Sortable from 'sortablejs';
    import ArticleForm from "./components/articleForm"
    import {changStatus, removeById,orderList} from "../../../utils/utils"
    const columns = [
        {
            title: " ",
            key: "list_order",
            width: "50px",
            dataIndex: "list_order",
            scopedSlots: {customRender: "list_order"}
        },
        {
            title: "功能名称",
            dataIndex: "name",
            ellipsis: true,width: "150px",
            key: "name"
        },
        {
            title: "功能描述",
            dataIndex: "description",
            // ellipsis: true,
            key: "description",
        },
      {
        title: "状态 ",
        key: "status",
        width: "150px",
        dataIndex: "status",
        scopedSlots: {customRender: "status"}
      },
        {
            title: "操作",
            key: "action",
            width: "150px",
            scopedSlots: {customRender: "action"}
        }
    ];
    export default {
        name: "index",
        data() {
            return {
                resetSeachdata:true,
                fieldNames: {label: 'name', value: 'id', children: 'children'},
                visibleImg: false,
                tableImg: "",
                seachList:[],
                seach: {
                    name: "",
                    category: undefined
                },
                pagination: {
                    pageNo: 1,
                    pageSize: 20, // 默认每页显示数量
                    onShowSizeChange: (pageSize) => (this.pageSize = pageSize), // 改变每页数量时更新显示
                    onChange: this.getList.bind(this), //点击页码事件
                    total: 0, //总条数
                    current: 0,
                    size: "small",
                    showTotal: total => `共 ${total} 条`,
                    showQuickJumper: true
                },
                data: [],
                columns,
                selectedRowKeys: [], // Check here to configure the default column
                loading: true,
                visible: false,
                title: "",
                editId: null
            }
        },
        created() {
            this.$store.state.adminleftnavnum = "/ai/assistant"; //设置左侧导航2-2 active
        },
        mounted() {
            this.getList()
          this.getSeach()
          this.$nextTick(() => {
            setTimeout(() => {
              this.drag()
            },500)
          })
        },
        components: {ArticleForm},
        computed: {

        },
        methods: {

            onChange(row) {
                let Json = {id: row.id, status: row.status == 2 ? 1 : 2}
                changStatus(API.service.CHANG_STATUS,  Json ).then(res => {
                    if (res == true) {
                        this.getList()
                    }
                })
            },

            resetSeach() {
                this.loading = true
                this.seach = {
                  name: "",
                  category: undefined
                }
                this.resetSeachdata=false
                this.getList(1)
            },

            drag () {
              const _this = this
              const el2 = document.querySelector('#tables table tbody')
              Sortable.create(el2, {
                handle:".dragicon",
                disabled: false, // 是否开启拖拽
                ghostClass: 'sortable-ghost', //拖拽样式
                animation: 150, // 拖拽延时，效果更好看
                group: { // 是否开启跨表拖拽
                  pull: false,
                  put: false
                },
                onEnd: ({ newIndex, oldIndex }) => { // 这里主要进行数据的处理，拖拽实际并不会改变绑定数据的顺序，这里需要自己做数据的顺序更改
                  let data=JSON.parse(JSON.stringify(_this.data))
                  console.log(data)
                  const currRow = data .splice(oldIndex, 1)[0]
                  data.splice(newIndex, 0, currRow)
                  let list_orders=[]
                  let dataJson={}
                  data.map((item,index)=>{
                    dataJson={}
                    dataJson.id=item.id
                    dataJson.list_order=index+1
                    list_orders=[...list_orders,dataJson]
                  })
                  API.service.ORDER_LIST(list_orders).then(res=>{this.loading = true; this.$message.success({ content:res.data.msg,duration: 2 }) ;this.getList() })
                  // this.getList()
                }
              });
            },

            getSeach() {
      API.service.GET_SEACH().then(res => {
        this.seachList = res.data.data,
        this.selectedRowKeys=[]
        if(!this.resetSeachdata==true)this.seach.update_time=[]
        this.resetSeachdata=true
        this.loading = false
      })
    },

            getList(page) {
                let seachData = JSON.parse(JSON.stringify(this.seach))


                API.service.GET_LIST({page: page || 1, ...seachData}).then(res => {
                    this.data = res.data.data
                    this.resetSeachdata=true
                    this.loading = false
                })
            },
            edit(id,type,show,ai_type){
              this.$router.push({path: '/ai/assistantEdit', query: {id:id,type,show,ai_type}})

            }
        }
    }
</script>

<style scoped>
    .seachBox .seachList .name {
        width: 70px !important;
    }

    .seachBox .seachList .seachs {
        width: calc(100% - 80px);
    }
    .dragicon{position: relative;display: inline-block;height:20px;cursor: pointer;margin-left: 10px}
    .inputs {
        display: inline-block;
        width: 70px
    }
</style>
